import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import type { OnInit } from '@angular/core';
import { Item } from './types';
import { AlertController, IonModal, IonSearchbar } from '@ionic/angular';
import { Keyboard } from '@capacitor/keyboard';
import { Capacitor } from '@capacitor/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-select-search-multiple',
  templateUrl: './select-search-multiple.component.html',
  styleUrls: ['./select-search-multiple.component.scss'],
  imports: [CommonModule, IonicModule, TranslateModule],
  standalone: true
})
export class SelectSearchMultipleComponent implements OnInit {
  @ViewChild('searchBar') searchBar: IonSearchbar | null = null;

  @Input() items: Item[] = [];
  @Input() selectedItems: number[] = [];
  @Input() title = 'Select Items';
  @Input() confirmWhenValueLess1 = false;

  @Output() selectionCancel = new EventEmitter<void>();
  @Output() selectionChange = new EventEmitter<number[]>();
  @Output() searchChange = new EventEmitter();
  
  workingSelectedValues: number[] = [];
  
  ngOnInit() {
     this.workingSelectedValues = [...this.selectedItems];
    setTimeout(() => {
      this.searchBar?.setFocus();
      if (Capacitor.getPlatform() !== 'web')
        Keyboard.show();
    }, 150);
  }
  
  trackItems(index: number, item: Item) {
    return item.id;
  }
  
  cancelChanges() {
    this.selectionCancel.emit();
    this.selectionChange.emit(this.workingSelectedValues);
  }
  
  confirmChanges() {
    this.selectionChange.emit(this.workingSelectedValues);
  }
  
  searchbarInput(ev: any) {
    this.searchChange.emit({'searchString' : ev.target.value, 'selectedIds': this.workingSelectedValues});
  }

  checkCB(event: any, item: any) {
    this.checkboxChange({'detail': {'checked': !this.isChecked(item['id']), 'value': item['id']}})
  }
  
  checkboxChange(ev: any) {
    const checked = ev.detail.checked;
    const value = ev.detail.value;
    
    if (checked) {
      this.workingSelectedValues = [
        ...this.workingSelectedValues,
        value
      ]
    } else {
      this.workingSelectedValues = this.workingSelectedValues.filter(item => item !== value);
    }

    if(this.confirmWhenValueLess1 && value == -1) {
      this.confirmChanges()
    }
  }

  isChecked(value: number) {
    return this.workingSelectedValues.find(item => item === value);
  }

  setToNull() {
    this.workingSelectedValues = [];
    this.selectionChange.emit(this.workingSelectedValues);
  }

}
